const PageHeader = ({ eyebrow, title, description }) => (
  <section className="relative overflow-hidden border-b border-border bg-brand-surface" data-testid="page-header">
    <div
      className="v-accent pointer-events-none absolute right-0 top-0 h-24 w-24 bg-brand-red/10"
      aria-hidden="true"
    />
    <div className="container-site py-16 lg:py-24">
      <div className="mb-4 h-1 w-12 bg-brand-red" aria-hidden="true" />
      <p className="eyebrow">{eyebrow}</p>
      <h1 className="mt-3 max-w-3xl text-4xl font-semibold sm:text-5xl">{title}</h1>
      {description && (
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-brand-grey md:text-lg">
          {description}
        </p>
      )}
    </div>
  </section>
);

export default PageHeader;
